/* Mirrors App\Services\Tenants\TenantProvisioningService (backend) — keep both in sync. */

export interface TenantRoleTemplate {
  name: string
  chamberOnly?: boolean
}

export const TENANT_ROLE_TEMPLATES: TenantRoleTemplate[] = [
  { name: 'Super Admin' },
  { name: 'Administrador de Setor' },
  { name: 'Operador' },
  { name: 'Secretário', chamberOnly: true }
]

export const DEFAULT_DOCUMENT_SUBJECTS: string[] = [
  'Decretos', 'Leis', 'Pedido de aposentadoria', 'Portaria de averbação', 'Arquivos de retorno',
  'Auxílio natalidade', 'Afastamento por aposentadoria', 'Circular', 'Portarias', 'Processos contábeis',
  'Folha (fopag)', 'Processos de pagamento', 'Relatórios de folha (fopag)', 'Renovação de contrato',
  'Requerimentos', 'Contracheque', 'Contratos', 'Dúvidas', 'Execução fiscal', 'Exoneração', 'Férias',
  'Extrato de publicação', 'Informações gerais', 'Parecer', 'Informações de folha', 'Licenças',
  'Nomeações', 'Mapa de cotação', 'Extrato de contrato', 'Extrato rescisão', 'Erratas', 'Afastamento',
  'Desincompatibilização', 'Falecimento de parente de servidor', 'Gratificação', 'Gid', 'Gip',
  'Licença maternidade', 'Prorrogação de licença maternidade', 'Licença paternidade',
  'Licença pra tratar de interesses particulares', 'Licença por motivo de doença em pessoa da família',
  'Nomeação', 'Processo administrativo', 'Redução de carga horária', 'Retorno às atividades'
]
